import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
export const OBJECT_TIMELINE_EVENTS_FIELDNAME = 'objectTimeline';
export const GET_TIMELINE_EVENTS_FOR_OBJECT = registerQuery({
  fieldName: OBJECT_TIMELINE_EVENTS_FIELDNAME,
  args: ['objectTypeId', 'objectId'],
  fetcher({
    objectId,
    objectTypeId
  }) {
    return http.get(`inbounddb-objects/v1/crm-objects/${objectTypeId}/${objectId}`, {
      query: {
        includeMergeAudits: true
      }
    });
  }
});